__webpack_require__.p = "/etc.clientlibs/cob-corp-acquisition/clientlibs/clientlib-react/resources/";